var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "infinity-list" },
    [
      _c("div", { staticClass: "gradient-start" }),
      _c("div", { staticClass: "background-list" }),
      _vm._t("default"),
      _vm.next_page && _vm.next_page !== 1
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "intersect",
                  rawName: "v-intersect.quiet",
                  value: _vm.onLoadNext,
                  expression: "onLoadNext",
                  modifiers: { quiet: true },
                },
              ],
              staticClass: "pt-5 text-center subtitle-1 text--secondary",
              staticStyle: { height: "30vh" },
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: "30",
                  width: "2",
                  color: "dark",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }